import { render, staticRenderFns } from "./BbeeCalidadPFC.vue?vue&type=template&id=bf721936"
import script from "./BbeeCalidadPFC.vue?vue&type=script&lang=js"
export * from "./BbeeCalidadPFC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports